import React, { FormEvent, useEffect, useRef, useState } from "react";
import "../assets/styles/components/contact_me.css";

function ContactForm() {
    const [result, setResult] = useState("");
    const statusTimerRef = useRef<number | undefined>(undefined);

    useEffect(() => () => window.clearTimeout(statusTimerRef.current), []);

    const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
        const form = event.currentTarget;
        try {
            event.preventDefault();
            setResult("Sending...");
            const formData = new FormData(form);
            formData.append("access_key", "5c822506-ad3e-4752-8d2d-22c6f40cb9ea");
            const response = await fetch("https://api.web3forms.com/submit", { method: "POST", body: formData });
            if (response.ok) {
                setResult("Thank you - your message was sent.");
                form.reset();
            } else {
                setResult("Something went wrong. Please try email or LinkedIn.");
            }
        } catch {
            setResult("Something went wrong. Please try email or LinkedIn.");
        } finally {
            window.clearTimeout(statusTimerRef.current);
            statusTimerRef.current = window.setTimeout(() => setResult(""), 6000);
        }
    };

    return (
        <form className="contact-form" onSubmit={onSubmit} noValidate>
            <h3 className="contact-form__title">Send a message</h3>
            <div className="contact-form__field">
                <label htmlFor="username">Name</label>
                <input required id="username" name="username" type="text" autoComplete="name" placeholder="Your name" />
            </div>
            <div className="contact-form__field">
                <label htmlFor="email">Email</label>
                <input
                    required
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    placeholder="you@example.com"
                />
            </div>
            <div className="contact-form__field">
                <label htmlFor="message">Message</label>
                <textarea required id="message" name="message" rows={5} placeholder="How can I help?" />
            </div>
            <div className="contact-form__actions">
                <button type="submit" className="btn-primary contact-form__submit">
                    Submit
                </button>
                <div className="contact-form__status" role="status" aria-live="polite">
                    {result}
                </div>
            </div>
        </form>
    );
}

export default ContactForm;
